import { useContext } from "react";
import { useAssignmentProposalStore } from "@context/useAssignmentProposalStore";
import type { ActiveProposal } from "@services/types/assignment-proposal/assignmentProposalTypes";
import { activeProposalOfLink } from "@utils/assignmentProposal";
import { AppContext } from "../context/EditSessionsContext";

/** The proposal the editor of the current link is bound to, if any. */
export const useActiveProposal = (): ActiveProposal | null => {
  const { state } = useContext(AppContext);
  const activeProposal = useAssignmentProposalStore(store => store.activeProposal);

  return activeProposalOfLink(activeProposal, state?.link?.info?.id);
};
